import React, { ReactElement } from 'react';

import FilterCheckbox from '@buyside/components/presentation/Filters/FilterCheckbox/filterCheckbox';
import FilterChecklist from '@buyside/components/presentation/Filters/FilterChecklist/filterChecklist';
import FilterSliderRange from '@buyside/components/presentation/Filters/FilterSliderRange/FilterSliderRange';
import FilterSelect from '@buyside/components/presentation/Filters/FilterSelect/filterSelect';
import FilterTextInput from '@buyside/components/presentation/Filters/FilterTextInput/filterTextInput';
import SelectableDropdown from '@buyside/components/presentation/SelectableDropdown/selectableDropdown';

import { generateRangeMapping } from '@buyside/util/filterSliderUtil/filterSliderUtil';
import { labelizedFilterListOptions } from '@buyside/components/presentation/Filters/filterUtil';
import { sliders } from '@buyside/util/ideaFilterConstants';
import formatNumber from '@buyside/util/formatNumber';

const {
  assetClasses,
  cities,
  fundStrategies,
  fundTypes,
  geographies,
  sectors
} = labelizedFilterListOptions;

const {
  aum_ranges: { increments: aumIncrements, ticks: aumTicks }
} = sliders;

export const renderOwnPostingsCheckbox = (shouldShow?: boolean): ReactElement => (
  <>{shouldShow && <FilterCheckbox text="Show my active postings" paramName="my_postings" />}</>
);

const JobPostingIndexFilters = (): ReactElement => (
  <>
    <FilterTextInput id="keyword-search-job-posting" placeholder="Keyword" paramName="text" />
    <SelectableDropdown title="City" overflowVisible>
      <FilterSelect paramName="city" options={cities} />
    </SelectableDropdown>
    <SelectableDropdown title="AUM Range">
      <FilterSliderRange
        paramName="aum_range"
        mapping={generateRangeMapping(aumIncrements, aumTicks, formatNumber)}
        increments={aumIncrements}
        handleTipFormatter={formatNumber}
        debounceDuration={1500}
      />
    </SelectableDropdown>
    <SelectableDropdown title="Firm Type">
      <FilterChecklist paramName="fund_types[]" filterList={fundTypes} />
    </SelectableDropdown>
    <SelectableDropdown title="Strategy">
      <FilterChecklist paramName="strategy[]" filterList={fundStrategies} />
    </SelectableDropdown>
    <SelectableDropdown title="Asset Class Mandate">
      <FilterChecklist paramName="asset_class[]" filterList={assetClasses} />
    </SelectableDropdown>
    <SelectableDropdown title="Sector Mandate">
      <FilterChecklist
        paramName="sectors[]"
        filterList={sectors.filter(({ label }) => label !== 'Unclassifiable')}
      />
    </SelectableDropdown>
    <SelectableDropdown title="Region Mandate">
      <FilterChecklist paramName="region[]" filterList={geographies} />
    </SelectableDropdown>
  </>
);

export default JobPostingIndexFilters;
